import { render, staticRenderFns } from "./ContentCredits.vue?vue&type=template&id=54b1805b&scoped=true&"
import script from "./ContentCredits.vue?vue&type=script&lang=js&"
export * from "./ContentCredits.vue?vue&type=script&lang=js&"
import style0 from "./ContentCredits.vue?vue&type=style&index=0&id=54b1805b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b1805b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
